import { ENVIRONMENT_INITIALIZER, NgModule, inject } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
  withHttpTransferCacheOptions,
} from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { RootComponent } from './components/root/root.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from '@angular/fire/compat';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { environment } from '../environments/environment';
import { LoginComponent } from './components/login/login.component';
import { AuthInterceptor } from './services/auth-interceptor.interceptor';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { FooterComponent } from './components/footer/footer.component';
import { ServicesCardComponent } from './components/services-card/services-card.component';
import { ResourcesCardComponent } from './components/resources-card/resources-card.component';
import { NotificationsListComponent } from './components/notifications-list/notifications-list.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { lottiePlayerFactory } from './services/lottie-player-factory';
import { ContactUsFormComponent } from '../../myt/utils/standalone-components/contact-us-form/contact-us-form.component';
import { ENVIRONMENT } from 'shared';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from './services/route-reuse.strategy';
import { LoadingModule } from '../../myt/modules/loading/loading.module';
import { HttpLoaderInterceptor } from './core/loading/interceptors/http-loader.interceptor';
import { APP_LOADER_POLICY_RULES } from './core/loading/config/loading-policy.config';
import { provideLoaderPolicyRules } from './core/loading/tokens/loader-policy.token';
import { RouteLoaderService } from './core/loading/services/route-loader.service';
import { SignupComponent } from '../../myt/utils/standalone-components/signup/signup.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { shouldIncludeInHttpTransferCache } from './core/hydration/http-transfer-cache.filter';

@NgModule({
  declarations: [
    RootComponent,
    LoginComponent,
    FooterComponent,
    ServicesCardComponent,
    ResourcesCardComponent,
    NotificationsListComponent,
  ],
  bootstrap: [RootComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgHttpLoaderModule.forRoot(),
    BrowserAnimationsModule,
    MatToolbarModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatInputModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    MatButtonToggleModule,
    MatCardModule,
    MatButtonModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    ContactUsFormComponent,
    SignupComponent,
    MatListModule,
    MatSidenavModule,
    MatExpansionModule,
    LottieComponent,
    LoadingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    ...provideLoaderPolicyRules(APP_LOADER_POLICY_RULES),
    { provide: HTTP_INTERCEPTORS, useClass: HttpLoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: ENVIRONMENT_INITIALIZER,
      multi: true,
      useValue: () => {
        inject(RouteLoaderService);
      },
    },
    provideClientHydration(
      withHttpTransferCacheOptions({
        filter: shouldIncludeInHttpTransferCache,
      }),
    ),
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { disableClose: true } },
    { provide: ENVIRONMENT, useValue: environment },
    provideLottieOptions({
      player: lottiePlayerFactory,
    }),
    { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
